<script>
    export let orders;
    export let from;
    export let to;

    import { chart } from "svelte-apexcharts";
    import { onMount } from "svelte";

    let p = 24 * 60 * 60 * 1000; // milliseconds in a day

    let incomeByDay;
    let mounted = false;

    function processOrders() {
        if (!orders || orders.length == 0) return;
        incomeByDay = {};

        orders = orders.filter((order) => !order.cancled); //remove cancled orders

        orders.forEach((order) => {
            let date = new Date(order.createdAt.seconds * 1000);
            let roundedDate = new Date(date.toDateString());
            let ts = roundedDate.getTime();

            if (!incomeByDay[ts]) {
                incomeByDay[ts] = order.sum;
            } else {
                incomeByDay[ts] += order.sum;
            }
        });

        const fromDate = new Date(new Date(from).toDateString());
        const toDate = new Date(new Date(to).toDateString());
        const msDay = 60 * 60 * 24 * 1000;
        const diffDays = Math.floor((toDate - fromDate) / msDay);
        let ts = new Date(fromDate);
        for (let i = 0; i <= diffDays; i++) {
            const inMs = ts.getTime();
            if (!incomeByDay[inMs]) incomeByDay[inMs] = 0;
            ts.setDate(ts.getDate() + 1);
        }

        let values = Object.entries(incomeByDay);
        values.sort((a, b) => a[0] - b[0]);
        values.map((val) => {
            val[0] = parseInt(val[0]);
            return val;
        });

        //TODO: fill in 0$ for empty days
        values.forEach((val) => {});

        let series = {
            name: "הכנסות לפי יום",
            data: values,
        };

        options.series = [series];
    }

    $: {
        if (orders && mounted) {
            processOrders();
        }
    }

    onMount(() => {
        mounted = true;
    });

    var options = {
        // markers: {size: 5},
        series: [],
        chart: {
            height: "350",
            type: "line",
            zoom: {
                enabled: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "straight",
        },
        tooltip: {
            shared: true,
            intersect: false,
        },
        xaxis: {
            type: "datetime",
        },
    };

</script>

<div class="chart">
    <div use:chart={options} />
</div>

<style>
    .chart {
        position: relative;
        border-radius: 4px;
        box-shadow: 0 3px 10px -10px;
        margin-bottom: 30px;
        padding: 15px 10px 10px 10px;
        background: rgb(255 255 255 / 90%);
        margin: 10px;
    }

</style>
